import { API } from 'src/api';

export const useUserAuthentication = () => {
  const fetchUserDetails = async () => {
    try {
      const response = await API.post(`/auth/check`);
      if (response.data) {
        return formatUserDetails(response.data);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        return formatUserDetails(error.response.data);
      }
    }
    return null;
  };

  return { fetchUserDetails };
};

export const isSiteUnderMaintanence = async () => {
  try {
    const response = await API.get('/status');
    if (response.data.live) {
      return false;
    } else if (response.data.live === false) {
      return true;
    }
  } catch (error) {
    console.error(error);
  }
  return false;
};

function formatUserDetails(data): UserDetails {
  const structuredData: Partial<UserDetails> = {};

  if (data && data.success) {
    structuredData.token = data?.user?.token;
    structuredData.intercomUserHash = data?.user?.intercomUserHash;
    structuredData.userId = data?.user?.me?.id;
    structuredData.avatarUrl = data?.user?.me?.avatar;
    structuredData.email = data?.user?.me?.email;
    structuredData.name = data?.user?.me?.name;
    structuredData.memberInformation = data?.user?.me?.activeMember;
    structuredData.memberInformation &&
      (structuredData.memberInformation.memberId = data?.user?.me?.activeMember._id);

    structuredData.showDefaultWorkspace = data?.user?.me?.showDefaultWorkspace;
    structuredData.organisations = data?.user?.organisations;
    structuredData.mode = data?.user?.op_mode === 'work' ? 'w' : 'a';
    structuredData.statistics = data?.user?.statistics;
    structuredData.timer = data?.user?.timer;
    structuredData.showCalendar = data?.config?.showCalendar || false;
    structuredData.showQuickFilter = data?.config?.showQuickFilter ?? true;
    structuredData.plan = data?.user?.plan;
    if (data.user.signUpQueries) {
      structuredData.authentication = 'userInfoPending';
    } else {
      structuredData.authentication = 'authorised';
    }
  } else {
    if (data?.type === 'Authentication error!') {
      structuredData.authentication = 'unAuthorised';
    } else if (data?.code) {
      structuredData.errorCode = data?.code;
    }
  }
  return structuredData as UserDetails;
}

export interface UserDetails {
  token: string;
  userId: string;
  avatarUrl: string;
  intercomUserHash: string;
  email: string;
  name: string;
  createdAt: string;
  mode: string;
  organisations: any[];
  memberInformation: {
    firstname: string;
    lastname: string;
    memberId: string;
    defaultWorkspace: string;
    tooltips: any;
    onboarded: boolean;
    fileOnboarded: boolean;
    productTour: {
      dashboard_academy: boolean;
      dashboard_workspace: boolean;
      files: boolean;
    };
    organisation: {
      name: string;
      organisationId: string;
      owner: string;
      owner_member: string;
      stageCompleted: boolean;
      members: { email: string; member: string; role: string; _id: string }[];
      avatar: string;
      logo?: string;
    };
    role: string;
    demoFile: string;
  };
  showDefaultWorkspace: boolean;
  statistics: any;
  timer?: {
    board: string;
    task: string;
    board_title: string;
    task_title: string;
    isRunning: boolean;
    startDate: string;
  };
  authentication: 'userInfoPending' | 'authorised' | 'unAuthorised';
  errorCode?: number;
  showCalendar?: boolean;
  showQuickFilter: boolean;
  plan: {
    type: string;
    expiry: Date;
    trial?: boolean;
  };
}
